<div *ngIf="isLoading">
  <div id="preloader">
    <div id="loader" class="loader">
      <div class="loader-container">
        <div class="loader-icon">
          <img src="../assets/img/logo/logo.png" alt="Preloader" />
        </div>
      </div>
    </div>
  </div>
</div>
